<template>
  <div>
    <!-- Кнопка Get price -->
  
    <b-button v-if="!hasTotalPrice && !isOutsiderAgreement" v-b-tooltip.hover title="Recalculate price" block
      :disabled="isEmptyCart" size="sm" variant="warning" @click="$emit('calculate-cart')">
      Get price ({{ agreementName ? agreementName : 'Stripe' }})
    </b-button>
  
    <!-- Кнопка Submit для нового заказа -->
    <b-button v-if="!isEditMode && (hasTotalPrice || isOutsiderAgreement)" block :disabled="isEmptyCart" size="sm"
      variant="success" @click="$emit('place-order')">
      {{ $t("route.submit") }} <span v-if="!isOutsiderAgreement">({{ $t("order.totalPrice") }} {{ displayTotalPrice
        }})</span>
    </b-button>
  
    <!-- Кнопка Update для редактирования заказа -->
    <b-button v-if="isEditMode && hasTotalPrice" block :disabled="isEmptyCart" size="sm" variant="success"
      @click="$emit('update-order')">
      {{ $t("route.update") }} ({{ $t("order.totalPrice") }}: {{ displayTotalPrice }})
    </b-button>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useDeviceStore } from "@/stores/device";

export default {
  name: 'OrderActions',
  props: {
    agreementName: {
      type: String,
      required: true
    },
    hasTotalPrice: {
      type: Boolean,
      default: false
    },
    isEmptyCart: {
      type: Boolean,
      default: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    displayTotalPrice: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapStores(useDeviceStore),
    isOutsiderAgreement() {
      return this.deviceStore.getAgreementName === "GMS Electronics Primar";
    }
  },
}
</script>
